import { connect } from 'react-redux';
import CommentTabs from '../../components/comments/commenttabs';

import { selectCommentType } from '../../actions/ui';

const mapStateToProps = function(state) {
	return {
		comments: state.comments,
		features: state.features,
		selected_type: state.ui.comment_type
	};
}

const mapDispatchToProps = function(dispatch) {
	return {
		selectCommentType: (type)=>dispatch(selectCommentType(type))
	};
}

const CommentTabsContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	undefined,
	{
		pure: true
	}
)(CommentTabs)

export default CommentTabsContainer;